import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import t from 'react-translate';

import NvModal, { ModalType } from 'shared/components/nv-modal';

import AiInsightsSetupModalBody, {
  AiInsightsSetupModalBodyProps,
  FormValues,
} from './ai-insights-setup-modal-body';
import { modalStyles } from './ai-insights-setup-modal-styles';

export type AiInsightsSetupModalProps = AiInsightsSetupModalBodyProps & {
  show: boolean;
};

const AiInsightsSetupModal = (props: AiInsightsSetupModalProps) => {
  const {
    show,
    onClose,
    onSave,
    currentVisibility,
    currentUseCustomContext,
    currentCustomContext,
    courseAliases,
    isCollection,
    isLinked,
  } = props;
  const translations = t.LECTURE_PAGES.COMPONENTS.AI_INSIGHTS;

  const methods = useForm<FormValues>({
    defaultValues: {
      insightVisibility: currentVisibility,
      useCustomContext: currentUseCustomContext ? 'true' : 'false',
      customContext: currentCustomContext,
    },
  });

  useEffect(() => {
    if (!show) return;
    methods.reset({
      insightVisibility: currentVisibility,
      useCustomContext: currentUseCustomContext ? 'true' : 'false',
      customContext: currentCustomContext,
    });
  }, [
    show,
    currentVisibility,
    currentUseCustomContext,
    currentCustomContext,
    methods,
  ]);

  return (
    <NvModal
      show={show}
      header={translations.MODAL_TITLE()}
      modalStyles={modalStyles}
      width={800}
      fullHeight={false}
      type={ModalType.DYNAMIC}
      onClose={onClose}
      body={
        <FormProvider {...methods}>
          <AiInsightsSetupModalBody
            onClose={onClose}
            onSave={onSave}
            courseAliases={courseAliases}
            currentVisibility={currentVisibility}
            currentUseCustomContext={currentUseCustomContext}
            currentCustomContext={currentCustomContext}
            isCollection={isCollection}
            isLinked={isLinked}
          />
        </FormProvider>
      }
    />
  );
};

export default AiInsightsSetupModal;
